"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isomorphicMetricsService = void 0;
const window_1 = require("../utils/window");
const client_1 = require("./isomorphic/client");
const isomorphicMetricsService = (isOneBox = false) => (0, window_1.isClientSide)()
    ? (0, client_1.getDefaultClientMetricsService)(isOneBox)
    :
        require('./isomorphic/server').getDefaultNodeServerMetricsService(isOneBox);
exports.isomorphicMetricsService = isomorphicMetricsService;
